export const interactionOperations = {
  PLUS: 'PLUS',
  MINUS: 'MINUS'
}
